export default {
	wei_zhi: "位置",
	zhu_ye: "主页",
	sheng_chan_ri_qi: "生产日期",
	ext_yan_se: "ext颜色",
	int_yan_se: "int颜色",
	wei_zhao_dao_shu_ju: "未找到数据",
	xuan_ze_zhu_zu_xi_fen: "选择主组细分",
	ji_shu: "计数",
	sou_suo_jie_guo: "搜索结果",
	che_liang_dai_ma: "车辆代码",
	che_liang_xin_xi: "车辆信息",
	pin_pai: "品牌",
	xing_hao_ming_cheng: "型号名称",
	sheng_chan_ri_qi_1: "生产日期",
	sheng_chan_shang: "生产商",
	mo_xing: "模型",
	"SOP-EOP-": "SOP-EOP-",
	di_pan_dai_ma: "底盘代码",
	deng_ji: "等级",
	bian_su_qi_lei_xing: "变速器类型",
	jia_shi_yuan_zhi_wei: "驾驶员职位",
	che_liang_lei_xing: "车辆类型",
	men: "门",
	fa_dong_ji_xing_hao: "发动机型号",
	qu_dai: "取代",
	gong_shuai_Kw: "功率Kw",
	ran_liao_lei_xing: "燃料类型",
	qu_dong_qi_xing_hao: "驱动器型号",
	"xin_10-1234567": "锌10-1234567",
	che_liang_sou_suo: "车辆搜索",
	pin_pai_xing_hao: "品牌型号",
	xin_10: "锌10",
	xing_hao_biao_shi_hao: "型号标识号",
	fen_lei_bian_hao: "分类编号",
	shu_ru_zhi_shao_7_wei_OE_dai_ma: "输入至少7位OE代码",
	di_pan_dai_ma_1: "底盘代码",
	huan_ying: "欢迎",
	ji_de: "记得",
	wang_ji: "忘记",
	zhu_ce: "注册",
	yong_hu_ming: "用户名",
	mi_ma: "密码",
	qing_shu_ru_yong_hu_ming: "请输入用户名",
	qing_shu_ru_zheng_que_de_yong_hu_ming: "请输入正确的用户名",
	qing_shu_ru_mi_ma: "请输入密码",
	qing_shu_ru_zheng_que_de_mi_ma: "请输入正确的密码",
	yong_hu_ming_huo_mi_ma_cuo_wu: "用户名或密码错误",
	fan_hui: "< 返回",
	bei_zhu: "备注",
	bu: "不",
	zhu_zu: "主族",
	hou_guo: "后果",
	"pin_pai_ming_cheng_/_xing_hao_ming_cheng": "品牌名称/型号名称",
	yi_jian_sou_suo_te_ding_xiang_mu: "一键搜索特定项目",
	yi_sun_ling_jian: "易损零件",
	wai_guan_ling_jian: "外观零件",
	OEM_xin_xi: "OEM信息",
	OEM_dai_ma: "OEM代码",
	OEM_ming_cheng: "OEM名称",
	qing_mei_su: "青霉素",
	geng_huan_ling_jian_xin_xi: "更换零件信息",
	jia_ge: "价格",
	xing_xiang: "形象",
	OES_pin_pai: "OES品牌",
	OES_dai_ma: "OES代码",
	OES_ming_cheng: "OES名称",
	guo_jia: "国家",
	OEM_dai_ma_1: "OEM代码",
	OEM_ming_cheng_1: "OEM名称",
	pin_pai_1: "品牌",
	mo_xing_1: "模型",
	ji_xiang___dai_ma: "机箱_代码",
	kai_shi_shi_jian: "开始时间",
	jie_shu_shi_jian: "结束时间",
	fa_dong_ji: "发动机",
	bian_su_qi: "变速器",
	cha_tu: "插图",
	OES_ling_jian_qing_dan: "OES零件清单",
	jian_rong_xing_hao_lie_biao: "兼容型号列表",
	fa_dong_ji_he_bian_su_qi: "发动机和变速器",
	di_pan_he_xuan_jia: "底盘和悬架",
	wai_bu_he_nei_bu: "外部和内部",
	pan_shi_zhi_dong_pian: "盘式制动片",
	pan_shi_zhuan_zi: "盘式转子",
	zhi_dong_ti: "制动蹄",
	zhi_dong_zong_beng: "制动总泵",
	chuan_dong_zhou_fang_chen_tao: "传动轴防尘套",
	lun_gu_zhou_cheng: "轮毂轴承",
	hou_xiao_yin_qi: "后消音器",
	jian_zhen_qi: "减震器",
	wen_ding_qi_lian_gan: "稳定器连杆",
	chuan_dong_zhou_zong_cheng: "传动轴总成",
	chi_lun_chi_tiao: "齿轮齿条",
	ji_you_lv_qing_qi: "机油滤清器",
	kong_qi_lv_qing_qi: "空气滤清器",
	shui_beng: "水泵",
	li_he_qi_gai: "离合器盖",
	li_he_qi_pian: "离合器片",
	"huo_hua_sai_/_dian_re_sai": "火花塞/电热塞",
	yang_qi_chuan_gan_qi: "氧气传感器",
	fa_dong_ji_zong_cheng: "发动机总成",
	bian_su_qi_zong_cheng: "变速器总成",
	qi_dong_ji_dian_ji: "起动机电机",
	leng_que_qi_ya_suo_ji: "冷却器压缩机",
	bian_ju_qi: "变矩器",
	kong_tiao_lv_qing_qi: "空调滤清器",
	qian_men: "前门",
	hou_men: "后门",
	qian_zhao_deng: "前照灯",
	qian_bao_xian_gang: "前保险杠",
	hou_bao_xian_gang: "后保险杠",
	wei_deng: "尾灯",
	hou_bo_li: "后玻璃",
	ce_shi_jing: "侧视镜",
	production_date: "生产日期",
	belts: "Belts",
	battery: "Battery",
	radiator: "Radiator",
	alternator: "Alternator",
	wiper: "Wiper",
	oe_name: "OE_NAME",
	start_end: "START/END",
	oem_code: "OEM Code",
	group_name_subgroup_name: "GROUP NAME/SUBGROUP NAME",
	sop: "SOP",
	eop: "EOP",
	oem_code_substitution_code: "OEM CODE/SUBSTITUTION CODE",
	oem_name_remark: "OEM NAME/REMARK",
	oes_code: "OES Code",
	model: "Model",
	grade: "Grade",
	transmission_type: "Transmission Type",
	drivers_position: "Drivers Position",
	engine_model: "Engine Model",
	displacement: "Displacement",
	windshield: "Windshield",
};
